var transitionFadeIn = function transitionFadeIn(options) {
  var transitionDelay = options.transitionDelay,
    transitionDuration = options.transitionDuration,
    transitionStatus = options.transitionStatus;
  switch (transitionStatus) {
    case 'entered':
      {
        return {
          opacity: 1
        };
      }
    case 'entering':
      {
        return {
          opacity: 1,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exited':
      {
        return {
          opacity: 0
        };
      }
    case 'exiting':
      {
        return {
          opacity: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    default:
      {
        // unmounted
        return {
          opacity: 0
        };
      }
  }
};
export { transitionFadeIn };